/**
 * petPortraits — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const petPortraitsPack: ToilePack = {
    slug: 'pet-portraits',
    category: 'petportrait',
    name: 'Pet portraits',
    tagline: tagline('portraits', 'animals', 'styles'),
    chips: chips('animals', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'dog', label: 'Royal general', subject: 'a golden retriever in a crimson dress uniform, epaulettes and medals'},
        {key: 'cat', label: 'Renaissance cat', subject: 'a grey tabby in a white ruff collar and velvet doublet'},
        {key: 'rabbit', label: 'Astronaut rabbit', subject: 'a lop-eared rabbit in a white spacesuit, helmet under one arm'},
    ],
    styles: [
        {key: 'oil', label: 'Royal oil', style: 'royal oil painting, old-master brushwork', palette: 'deep chiaroscuro, dark ground', framing: 'centered portrait, gilt-frame feel'},
        {key: 'watercolor', label: 'Watercolor', style: 'watercolor, soft wet washes and pencil linework', palette: 'pale ground, bare paper at the edges', framing: 'centered portrait, looking at the viewer'},
        {key: 'popart', label: 'Pop-art', style: 'pop-art, thick black outlines and halftone dots', palette: 'flat bold blocks, saturated ground', framing: 'centered portrait, looking at the viewer'},
    ],
    directions: ['a french bulldog instead', 'against a deep green ground', 'dressed as a sea captain'],
}
